import React from "react";
import CanvasElement from "./CanvasElement";

export interface Props {
  elements: CanvasElement[];
  width: number;
  height: number;
  className?: string;
  ariaLabel?: string;
}

interface State {}

export default class SimpleCanvas extends React.Component<Props, State> {
  private canvasRef = React.createRef<HTMLCanvasElement>();
  private intervalId: number | undefined = undefined;
  private handlePointerDown: ((event: PointerEvent) => void) | null = null;

  public componentDidMount() {
    const canvas = this.canvasRef.current!;
    this.handlePointerDown = (event: PointerEvent) => {
      const bounds = canvas.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const mouseX =
        ((event.clientX - bounds.left) * canvas.width) / bounds.width;
      const mouseY =
        ((event.clientY - bounds.top) * canvas.height) / bounds.height;
      this.props.elements.forEach((element) => {
        if (element.containsPoint(mouseX, mouseY)) {
          element.onClick(this.props.elements);
        }
      });
    };
    canvas.addEventListener("pointerdown", this.handlePointerDown);
    this.start(canvas);
  }

  public componentWillUnmount() {
    if (this.intervalId !== undefined) {
      clearInterval(this.intervalId);
    }
    if (this.canvasRef.current && this.handlePointerDown) {
      this.canvasRef.current.removeEventListener(
        "pointerdown",
        this.handlePointerDown
      );
    }
  }

  public simulate() {
    this.props.elements.forEach(
      (element) => element._simulate && element._simulate(this.props.elements)
    );
  }

  public draw(canvas: HTMLCanvasElement) {
    const ctx = canvas.getContext("2d");
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    this.props.elements.forEach(
      (element) => element._draw && element._draw(canvas)
    );
  }

  public start(canvas: HTMLCanvasElement) {
    const framesPerSecond = 60;
    this.intervalId = window.setInterval(() => {
      this.simulate();
      this.draw(canvas);
    }, 1000 / framesPerSecond);
  }

  public render() {
    const { width, height, className, ariaLabel } = this.props;
    return (
      <canvas
        ref={this.canvasRef}
        width={width}
        height={height}
        className={className}
        aria-label={ariaLabel}
        style={{
          border: className ? undefined : "black solid 1px",
          maxWidth: "100%",
          height: "auto",
          touchAction: "manipulation"
        }}
      />
    );
  }
}
